import { isIntelbrasTenant } from '../isIntelbrasTenant/isIntelbrasTenant';

export const isDashCustomizationAllowed = () => {
  // Dash criada a partir da Intelbras é sempre Intelbras (domínio e tema próprios).
  if (isIntelbrasTenant()) return false;

  // auth-user corrompido não pode derrubar a tela de criação de conta.
  try {
    const user = JSON.parse(localStorage.getItem('auth-user'));

    return (
      Array.isArray(user?.permissions) &&
      user.permissions.some(
        (permission) =>
          permission?.role_id === 'DASH_CUSTOMIZATION' && !!permission.status,
      )
    );
  } catch {
    return false;
  }
};
